export default __webpack_public_path__ + "static/media/Shreya-Technical - 717_SHREYA.8f7706cd.jpeg";